/*
 * Created with JetBrains WebStorm.
 * User: mslobozeanu
 * Date: 15/06/2015
 */

/** @namespace TS */
/** @namespace TS.domain.properties */

TS.ns('TS.domain.properties');

(function () {
    'use strict';

    /**
     * @class TS.domain.properties.TreeListProperty
     * @ignore
     */
    TS.domain.properties.TreeListProperty = new Class(
        /** @lends TS.domain.properties.TreeListProperty# */
        {
            Extends: TS.domain.properties.BindingListProperty,

            observables: {
                SelectedItem: null,
                SelectedItemId: null,
                Selection: null,
                Identifier: 'UID',
                AllowAdd: true,
                AllowEdit: true,
                AllowDelete: true
            },

            defaults: {
                Identifier: 'UID'
            },

            initialize: function (domain, config) {
                this.parent(domain, config);
                if (config.Provider) {
                    this._hierarchyProvider = TS.domain.HierarchyProvider.create(this, config.Provider);
                }
            },

            getHierarchyFields: function () {
                if (this._hierarchyProvider) {
                    return this._hierarchyProvider.getHierarchyFields();
                }
            },

            getHierarchyProvider: function () {
                return this._hierarchyProvider;
            }
        });

    TS.ObjectFactory.map('TreeListProperty', TS.domain.properties.TreeListProperty);

    var hierarchyProviders = {};

    TS.domain.HierarchyProvider = new Class({
        initialize: function (config) {
            Object.append(this, config);
        },

        _setTreeListProperty: function (property) {
            this._treeListProperty = property;
        },

        _plainData: function (data) {
            if (!data)
                return data;
            return ko.mapping.toJS(data);
        },

        _getData: function () {
            if (!this._data) {
                this._data = this._plainData(this._treeListProperty.getListSource());
            }
            return this._data || [];
        },


        getHierarchyFields: function () {
            return {};
        },

        read: function (options) {
            options.success(this._getData());
        },

        update: function (options) {
            options.success(options._getData());
        },

        create: function (options) {
            options.success(options._getData());
        },

        destroy: function (options) {
            options.success(options._getData());
        }
    });


    TS.domain.HierarchyProvider.create = function (property, config) {
        var hierarchyProviderType = hierarchyProviders[config.Type];
        if (hierarchyProviderType) {
            var hierarchyProvider = new hierarchyProviderType(config);
            hierarchyProvider._setTreeListProperty(property);
            return hierarchyProvider;
        }
    };

    TS.domain.HierarchyProvider.register = function (name, type) {
        hierarchyProviders[name] = type;
    };

    TS.domain.AdjacencyListProvider = new Class({
        Extends: TS.domain.HierarchyProvider,

        initialize: function (config) {
            this.parent(config);
        },

        getHierarchyFields: function () {
            return {
                idField: this.IdField,
                fields: {
                    parentId: {from: this.ParentIdField, nullable: true}
                }
            };
        }
    });
    TS.domain.HierarchyProvider.register('AdjacencyList', TS.domain.AdjacencyListProvider);

    TS.domain.ReferenceHierarchyProvider = new Class({});
})();